export default "__VITE_ASSET__316c7587__"